module.exports = __webpack_public_path__ + "img/Images reseaux sociaux gif 4.bbc0c6b0.png";